export default __webpack_public_path__ + "static/media/saleslistings_icon-02.48361d5f.svg";